<template>
  <div class="avatar-box" :style="style">
    <div class="avatar">
      <img v-if="avatar" :src="imgSrc" @click.stop="handlePreview">
      <template v-else>
        <base-icon v-if="gender === 2" name="mine_default_women" />
        <base-icon v-else-if="gender === 1" name="mine_default_man" />
        <base-icon v-else name="img_user_default" />
      </template>
    </div>
    <div class="gender" :class="{ 'gender-male': gender === 1, 'gender-female': gender === 2 }" />
  </div>
</template>

<script>
import { isDef, addUnit, objToStyle } from '../utils/common';
import { ImagePreview } from 'vant';
export default {
  name: 'AppAvatar',
  props: {
    avatar: String,
    gender: Number,
    preview: Boolean,
    width: {
      type: [Number, String],
      default: 36,
    },
    height: {
      type: [Number, String],
      default: 36,
    },
    round: {
      type: Boolean,
      default: true,
    },
    blur: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imgSrc() {
      let src = `${this.avatar}?x-oss-process=image/resize,m_lfit,h_${this.height * 2},w_${this.width *
        2}/quality,q_100`;
      if (this.blur) {
        src += '/blur,r_20,s_20';
      }
      return src;
    },
    style() {
      const style = {};
      if (isDef(this.width)) {
        style.width = addUnit(this.width);
      }

      if (isDef(this.height)) {
        style.height = addUnit(this.height);
      }
      if (this.round) {
        style['border-radius'] = '50%';
      }
      return objToStyle(style);
    },
  },
  methods: {
    handlePreview() {
      if (!this.preview) {
        return;
      }
      ImagePreview({
        images: [this.avatar],
        swipeDuration: 300,
        closeOnPopstate: true,
        showIndicators: false,
        showIndex: false,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bg-image(@name) {
  background-image: url("../assets/image/@{name}@2x.png");
  @media (-webkit-min-device-pixel-ratio: 3), (min-device-pixel-ratio: 3) {
    background-image: url("../assets/image/@{name}@3x.png");
  }
}

.avatar-box {
  position: relative;
  background-color: #f8f8f8;
  .avatar {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      object-position: center;
    }
  }
  .gender {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 30px;
    height: 30px;
    background-size: cover;
    &-male {
      .bg-image("ic_male");
    }
    &-female {
      .bg-image("ic_female");
    }
  }
}
</style>
